import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "paragraghFullhtml" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fullHtml.js_code != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            innerHTML: _ctx.fullHtml.value
          }, null, 8, _hoisted_2),
          _createElementVNode("div", { innerHTML: _ctx.jsGen }, null, 8, _hoisted_3)
        ], 64))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          innerHTML: _ctx.fullHtml.value
        }, null, 8, _hoisted_4))
  ]))
}